import { type } from "../charge/utils";
import { isPlainObject, withProperties } from "../utils";



const eNairaPaymentOptions = Object.freeze([
    { name: 'QR', identifier: 'QR', label: 'QR' },
    { name: 'Token', identifier: 'TOKEN', label: 'Token' },
    { name: 'Direct Wallet Debit', identifier: 'DIRECT_WALLET_DEBIT', label: 'Direct Wallet Debit' },
])


function selectEnairaPaymentOptionFromList(list, eNairaOption) {
    if (type(list) !== 'array') return null;

    if (list.indexOf(eNairaOption) < 0) {
        const isEnairaPaymentOptionObject = isPlainObject(eNairaOption);

        const { name: eNairaOptionName, identifier: eNairaOptionIdentifier } =
         isEnairaPaymentOptionObject
            ? eNairaOption
            : (eNairaOption = String(eNairaOption), { name: eNairaOption, identifier: eNairaOption });

        eNairaOption = list.find(item => {
            if (isPlainObject(item)) {
                const { name, identifier } = item;

                const hasName = typeof eNairaOptionName !== 'undefined';
                const hasIdentifier = typeof eNairaOptionIdentifier !== 'undefined';

                let matches = (hasName || hasIdentifier) ? 1 : 0;

                if (isEnairaPaymentOptionObject) {
                    hasName && (matches = matches & (eNairaOptionName === name));
                    hasIdentifier && (matches = matches & (eNairaOptionIdentifier === identifier));
                } else {
                    matches = matches & (
                        hasName && eNairaOptionName === name || 
                        hasIdentifier && eNairaOptionIdentifier === identifier
                    );
                }

                return matches;
            }
        });
    }
    return eNairaOption || null;
}


export {
    eNairaPaymentOptions,
    selectEnairaPaymentOptionFromList
}